import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "./home.jsx";

export const store = configureStore({
  reducer: {home:homeReducer},
});
